"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPackagesService = exports.providers = void 0;
var providers;
(function (providers) {
    providers["HERE"] = "here";
    providers["TOMTOM"] = "tomtom";
    providers["GARMIN"] = "garmin";
})(providers || (exports.providers = providers = {}));
class MapPackagesService {
    constructor(authService, stage) {
        this.authService = authService;
        this.resourceHostId = `cwat-vw-navigation-map-update-service-${stage}`;
    }
    ;
    async getMapPackages(vin) {
        const url = `packages/${vin}`;
        const response = await this.authService.get(this.resourceHostId, url);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
}
exports.MapPackagesService = MapPackagesService;
//# sourceMappingURL=MapPackagesService.js.map